<template>
	<popup-view class="date-popup-view" v-bind="$attrs" @close="$emit('close')" :style="suggestions.length == 0 ? {
		gridTemplateColumns: 1
	} : {
		gridTemplateColumns: 2
	}">
		<date-picker-std-view class="picker" :value="value" @input="input" />
		<div class="buttons">
			<div @click="today">I dag</div>
			<div @click="reset">Nulstil</div>
		</div>
		<div v-if="suggestions.length > 0" class="suggestions">
			<div class="title">Forslag</div>
			<div class="item" v-for="(s, i) in suggestions" :key="i" @click="set(s.date)"><span>{{ s.date | date }}</span> {{ s.label }}</div>
		</div>
	</popup-view>
</template>

<script>
	import DatePickerStdView from './DatePickerStdView'

	export default {
		components: {
			datePickerStdView: DatePickerStdView
		},
		props: {
			value: {
				type: String
			},
			owner: {
				
			},
			suggestions: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			input(value) {				
				if (this.owner) {
					this.owner.input(value);
				}
			},
			today() {
				this.input((new Date()).format('Y-m-d'));
			},
			reset() {
				this.input(null);
			},
			set(date) {
				this.input(date);
			}	
		}
	}
</script>

<style lang="scss" scoped>
	.date-popup-view {
		display: grid;
		grid-template-rows: 2;

		& > .picker {
			grid-column: 1 / 2;
			grid-row: 1 / 2;
		}

		& > .buttons {
			grid-column: 1 / 2;
			grid-row: 2 / 3;

			display: grid;
			grid-template-columns: 1fr 1fr;
			margin-bottom: 20px;

			& > div {
				cursor: pointer;
				text-align: center;
				line-height: 30px;
			}
		}

		& > .suggestions {
			grid-column: 2 / 3;
			grid-row: 1 / 3;
			overflow: hidden;
			border-left: 1px solid #CECECE;
			padding: 15px 30px 20px 20px;

			& > .title {
				line-height: 30px;
			}

			& > .item {
				cursor: pointer;
				line-height: 20px;
				font-size: 12px;

				& > span {
					color: #a7a7a7;
					font-size: 12px;
				}
			}
		}
	}
</style>